<template>
	<app-page>
		<app-heading :title="isNew ? 'New User' : user.email" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'users' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					type="email"
					label="Email"
					v-model="user.email"
					:errors="errors.email"
					required
				/>
				<input-text
					label="First name"
					v-model="user.firstname"
					:errors="errors.firstname"
				/>
				<input-text
					label="Last name"
					v-model="user.lastname"
					:errors="errors.lastname"
				/>
				<input-text v-if="isNew"
					type="password"
					label="Password"
					v-model="user.password"
					:errors="errors.password"
					required
				/>
				<input-timezone
					label="Timezone"
					v-model="user.timezone"
					:errors="user.timezone"
				/>
				<input-select
					label="Role"
					v-model="user.role"
					:items="roles"
					:errors="errors.role"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		try {
			this.roles = await this.$ravello.graphql('roles').datasource().query()

			if (this.id !== 'new') {
				this.$store.dispatch('app/startLoading')
				const user = await this.$ravello.request().to('users').to(this.id).get()
				this.user = {
					email: user.email,
					firstname: user.firstname,
					lastname: user.lastname,
					role: user.role,
					timezone: user.timezone,
				}
				this.$store.dispatch('app/stopLoading')
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
	},
	data() {
		return {
			roles: [],
			user: {
				email: '',
				password: '',
				firstname: '',
				lastname: '',
				role: '',
				timezone: null,
			},
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.user
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request().to('users').create(this.user)
				} else {
					await this.$ravello.request().to('users').to(this.id).update(this.user)
				}
				this.$store.dispatch('app/stopLoading')
				this.$router.push({ name: 'users' })
				this.$notifications.pushAlert('success', `User successfully ${this.isNew ? 'added' : 'updated'}`)
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}

				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
